export const IconArrowRight = ({size = 14}: { size?: number }) => {
    return <svg width={size} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 11.25L13 6M13 6L8 0.75M13 6L1 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>

}
